import React from 'react';
/* eslint-disable */
export const IconAdBlockerNotification = () => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Not working icon 64px">
        <g id="Ellipse 3588" filter="url(#filter0_b_21389_91026)">
        <circle cx="32" cy="32" r="30" fill="white" fillOpacity="0.5"/>
        <circle cx="32" cy="32" r="29" stroke="#333F48" strokeWidth="2"/>
        </g>
        <path id="Line 34" d="M21 21L43.6274 43.6274" stroke="#FF3D00" strokeWidth="2" strokeLinecap="round"/>
        <path id="Line 35" d="M43.627 21L20.9995 43.6274" stroke="#FF3D00" strokeWidth="2" strokeLinecap="round"/>
        </g>
        <defs>
        <filter id="filter0_b_21389_91026" x="-2" y="-2" width="68" height="68" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/>
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_21389_91026"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_21389_91026" result="shape"/>
        </filter>
        </defs>
    </svg>
);
